import { render, staticRenderFns } from "./DirectRequiredCard.vue?vue&type=template&id=09ae478c"
import script from "./DirectRequiredCard.vue?vue&type=script&lang=js"
export * from "./DirectRequiredCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports